import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/portfolio/portfolio-content.jsx");
